import React from 'react'

const NotFoundView = () => {
	return (
		<div>NotFoundView</div>
	)
}

export default NotFoundView